var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefShirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m269 48.8-46-21.9h-.1c-1.2-.6-2.5-.9-3.9-.9l-48.4-.1c-5.1 0-9.2 4.1-9.2 9.1 0 12.6-10.4 22.8-23.1 22.8-12.7 0-23-10.3-23-22.9 0-5-4.1-9.2-9.2-9.2l-48.5-.2c-1.4 0-2.7.3-3.9.9h-.1L7.5 48.1c-3.2 1.5-5.3 4.7-5.3 8.2L2 130.5c0 3.1 1.6 6.1 4.3 7.7 1.5.9 3.2 1.4 4.9 1.4 1.4 0 2.7-.3 4-.9l33-15.5-.3 103.3c0 5 4.1 9.2 9.2 9.2l161.4.4c5.1 0 9.2-4.1 9.2-9.1l.3-103.3 32.9 15.7c1.3.6 2.6.9 4 .9 1.7 0 3.4-.5 4.9-1.4 2.7-1.7 4.3-4.6 4.3-7.7l.2-74.2c-.1-3.5-2.1-6.7-5.3-8.2zm-90.5-1.2-.5 179.7-29.7-.1.4-157.2c12.8-2.9 23.6-11.2 29.8-22.4zm-49.9 22.3-.4 157.2-29.7-.1.5-179.7c6.1 11.3 16.8 19.7 29.6 22.6zM10.1 130.2l.2-71.4 30.2-17.3-.2 71.4-30.2 17.3zm50.6-94.6h18.1L78.3 227H60.2l.5-191.4zm155.6 191.8h-18.1l.5-191.4h18.1l-.5 191.4zm50.6-96.6-30.2-17.4.2-71.4 30.2 17.4-.2 71.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefShirt);
export default __webpack_public_path__ + "static/media/ref_shirt.381e3709392c5a2be1dfdcd3d0ab3b24.svg";
export { ForwardRef as ReactComponent };